export function lockScroll() {
  document.body.style.overflowY = "hidden";
  document.body.style.maxHeight = "100vh";
}

export function unlockScroll() {
  document.body.style.overflowY = "unset";
  document.body.style.maxHeight = "unset";
}
